// extracted by mini-css-extract-plugin
export default {"container":"CharacterCount_container__o9jpG","error":"CharacterCount_error__bi66q","errorMsg":"CharacterCount_errorMsg__s4wNw"};